import { createContext, useContext, useState } from 'react';

// Single bottom-right utility dock: which tab is open (null | 'activity' | 'chat') + chat unread count for the trigger badge
const DockContext = createContext({ tab: null, setTab: () => {}, chatUnread: 0, setChatUnread: () => {} });

export function DockProvider({ children }) {
  const [tab, setTab] = useState(null);
  const [chatUnread, setChatUnread] = useState(0);
  return <DockContext.Provider value={{ tab, setTab, chatUnread, setChatUnread }}>{children}</DockContext.Provider>;
}

export const useDock = () => useContext(DockContext);
